import React, { PureComponent } from 'react';

import styled, { css } from 'styled-components';

import CenteredContainer from './CenteredContainer';
import FixedContainer from './FixedContainer';

const Header = styled(FixedContainer)`
  ${({ theme, headerBorder }) => css`
    top: ${theme.constants.navbarHeight};
    ${headerBorder &&
      css`
        border-bottom: 1px solid ${theme.colors.materialOrder.qa.headerBorder};
        box-shadow: ${theme.colors.materialOrder.qa.headerShadow};
      `}
  `}
`;

export default class FixedHeader extends PureComponent {
  render() {
    const { innerRef, children, headerBorder } = this.props;

    return (
      <Header innerRef={innerRef} headerBorder={headerBorder}>
        <CenteredContainer>{children}</CenteredContainer>
      </Header>
    );
  }
}
